import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IEmployeeImport } from '@api/types'
import { EmployeeImportFragment } from '@api/fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        imports: {
          edges: Array<{ node: IEmployeeImport }>
        }
      }
    }
  }
}

export default function isActive(): Promise<IEmployeeImport | undefined> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            imports: { edges },
          },
        },
      },
    }: IPayload) => {
      return edges.find(({ node: { status } }) => status === 'pending' || status === 'queued')?.node
    }
  )
}

const query = gql`
  query isActive {
    viewer {
      company {
        imports(first: 1) {
          edges {
            node {
              ...EmployeeImportFragment
            }
          }
        }
      }
    }
  }
  ${EmployeeImportFragment}
`
